import { Component, Input } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { ScanCvService } from '../scan-cv/services/scan-cv/scan-cv.service';
import { Router } from '@angular/router';
import { PaymentService } from 'src/app/services/payment/payment.service';
import {
  FormatResponse,
  JobRankingResponse,
  ScanResultApiResponse,
} from './services/scan-result/ScanResultDetails';

@Component({
  selector: 'app-scan-result',
  templateUrl: './scan-result.component.html',
  styleUrls: ['./scan-result.component.css'],
})
export class ScanResultComponent {
  @Input() rawData: ScanResultApiResponse | null = null;

  formatResponse: FormatResponse | null = null;
  jobRanking: JobRankingResponse | null = null;

  cvScores: any = {};
  contentData: any;
  user: any;
  openLists: Record<string, boolean> = {};
  isArabic: boolean = false;

  constructor(
    private content: FetchDataService,
    private translate: TranslateService,
    private scanCvService: ScanCvService,
    private PaymentService: PaymentService,
    private router: Router,
  ) {
    this.user = JSON.parse(localStorage.getItem('userInfo')!);
    const navigate = this.router.getCurrentNavigation();

    if (navigate?.extras.state) {
      const state = navigate.extras.state;

      const formData = new FormData();

      formData.append('cv', state['data']);
      if (state['jobTarget'] || state['jobDescription']) {
        const jobJson = JSON.stringify({
          jobTarget: state['jobTarget'] ?? '',
          jobDescription: state['jobDescription'] ?? '',
        });
        formData.append(
          'job',
          new Blob([jobJson], { type: 'application/json' }),
        );
      }
      if (state['lang']) {
        formData.append('lang', state['lang']);
      }

      this.scanCvService.scanCv(formData).subscribe((res: any) => {
        const data = res as ScanResultApiResponse;
        this.rawData = data;
        this.formatResponse = data.formatResponse;
        this.jobRanking = data.jobRankingResponse;
        this.calculateAllScores(data.formatResponse);
      });
    }
  }

  ngOnInit(): void {
    this.isArabic = this.translate.currentLang === 'ar';

    this.loadContent(this.translate.currentLang);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.isArabic = event.lang === 'ar';
      this.loadContent(event.lang);
    });
  }

  loadContent(lang: string): void {
    this.content.getContentData(lang, 'scan-result').subscribe({
      next: (data) => {
        this.contentData = data;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
 calculateAllScores(formatResponse: FormatResponse): void {
    const manualScore = this.calculateScore(formatResponse);
    this.cvScores.total = this.jobRanking?.overallScore != null
      ? parseFloat(((this.jobRanking.overallScore + manualScore) / 2).toFixed(1))
      : manualScore;
    this.cvScores.headline   = this.calculateScore(formatResponse.headline);
    this.cvScores.format     = this.calculateScore(formatResponse.format);
    this.cvScores.summary    = this.calculateScore(formatResponse.summary);
    this.cvScores.experience = this.calculateScore(formatResponse.experience);
    this.cvScores.education  = this.calculateScore(formatResponse.education);
  }


  toggleList(key: string): void {
    this.openLists[key] = !this.openLists[key];
  }

  getCheckIcon(fieldName: string): string {
    const fieldValue = this.findFieldValue(this.formatResponse, fieldName);
    return fieldValue === 1
      ? 'assets/icon/right check.png'
      : 'assets/icon/wrong-check.png';
  }

  getScoreBadgeClass(score: number): string {
    if (score >= 80) return 'high';
    if (score >= 50) return 'medium';
    return 'low';
  }

  getCircleDash(score: number): string {
    const circumference = 2 * Math.PI * 15.9;
    const filled = (score / 100) * circumference;
    return `${filled} ${circumference}`;
  }

  private findFieldValue(data: any, fieldName: string): any {
    if (data === null || data === undefined) return undefined;
    if (Array.isArray(data)) {
      for (const item of data) {
        const result = this.findFieldValue(item, fieldName);
        if (result !== undefined) return result;
      }
    } else if (typeof data === 'object') {
      for (const key in data) {
        if (key === fieldName) return data[key];
        const result = this.findFieldValue(data[key], fieldName);
        if (result !== undefined) return result;
      }
    }
    return undefined;
  }

  calculateScore(data: any): number {
    let total = 0;
    let count = 0;
    function traverse(section: any) {
      if (Array.isArray(section)) {
        section.forEach((item) => traverse(item));
      } else if (typeof section === 'object' && section !== null) {
        Object.values(section).forEach((value) => {
          if (typeof value === 'number') {
            total += value;
            count++;
          } else {
            traverse(value);
          }
        });
      }
    }
    traverse(data);
    return count === 0 ? 0 : parseFloat(((total / count) * 100).toFixed(1));
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
